import { useAuth } from '../contexts/AuthContext';
import { useFamily } from './useFamily';

/**
 * User id whose recipe engagement (likes, saves, flags on lists) should be shown/edited.
 * - Guests: undefined (no profileId sent; APIs use anonymous/default behavior).
 * - Doctors: always the logged-in user (no family profile switching).
 * - Patients: selected family profile, or self when none / same account.
 */
export function useActingEngagementProfileId(): string | undefined {
  const { user, isAuthenticated, isLoading, isDoctor } = useAuth();
  const { activeUserId } = useFamily();

  if (isLoading || !isAuthenticated || user?.id == null) {
    return undefined;
  }

  const selfId = String(user.id);

  if (isDoctor()) {
    return selfId;
  }

  if (activeUserId && String(activeUserId).trim() !== '') {
    return String(activeUserId);
  }

  return selfId;
}
